'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { GroupField, LinkField, KeyTextField } from '@prismicio/client';
import { PrismicNextLink } from '@prismicio/next';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import Link from '@/components/atoms/Link';
import LinkButton from '@/components/atoms/LinkButton';
import SiteLogo from '@/components/atoms/SiteLogo';
import { useIsWideDesktop } from '@/hooks/useMediaQuery';
import useOutsideClickHandler from '@/hooks/useOutsideAlerter';
import useScrollLock from '@/hooks/useScrollClock';
import useScrollDetect from '@/hooks/useScrollDetect';
import { ConfigDocumentDataButtonItemsItem, HeaderItemDocument, Simplify } from '@/prismicio-types';
import ChevronDown from '@/public/assets/svg/chevron-down.svg';
import HamburgerClosed from '@/public/assets/svg/close.svg';
import HamburgerOpen from '@/public/assets/svg/menu.svg';
import ProfileTwoUserIcon from '@/public/assets/svg/profile-two-user.svg';
import { Lang } from '@/types/locales';
import DropdownItem from '../DropdownItem';
import { LanguageSwitcher } from '../LanguageSwitcher';
type Props = {
  headerItems: HeaderItemDocument<string>[];
  buttonItems: GroupField<Simplify<ConfigDocumentDataButtonItemsItem>>;
  myAccountLink?: LinkField;
  myAccountText?: KeyTextField;
  lang: Lang;
};
const Menu = t0 => {
  const $ = _c(82);
  const {
    headerItems,
    buttonItems,
    myAccountLink,
    myAccountText,
    lang
  } = t0;
  const ref = useRef(null);
  const [openTab, setOpenTab] = useState(-1);
  const [prevTab, setPrevTab] = useState(0);
  const [showMenu, setShowMenu] = useState(false);
  const isDesktop = useIsWideDesktop();
  const timeoutRef = useRef(null);
  let t1;
  if ($[0] !== openTab) {
    t1 = () => {
      setPrevTab(openTab > -1 ? openTab : 0);
      setOpenTab(-1);
      setShowMenu(false);
    };
    $[0] = openTab;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hideMenuOnClick = t1;
  const handleMenuHover = index => {
    if (isDesktop) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setPrevTab(openTab > -1 ? openTab : 0);
      setOpenTab(index);
    }
  };
  let t2;
  if ($[2] !== isDesktop || $[3] !== openTab) {
    t2 = () => {
      if (isDesktop) {
        timeoutRef.current = setTimeout(() => {
          setPrevTab(openTab);
          setOpenTab(-1);
        }, 200);
      }
    };
    $[2] = isDesktop;
    $[3] = openTab;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleMenuLeave = t2;
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    t4 = [];
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== openTab) {
    t5 = () => {
      setPrevTab(openTab > -1 ? openTab : 0);
      setOpenTab(-1);
    };
    $[7] = openTab;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useOutsideClickHandler(ref, t5);
  useScrollLock(showMenu && !isDesktop || openTab !== -1 && isDesktop);
  const movedScroll = useScrollDetect();
  const isMyAccountLink = myAccountLink && myAccountLink.link_type !== "Any" && myAccountText;
  const t6 = showMenu && "h-screen overflow-y-auto bg-white xl:bg-transparent";
  let t7;
  if ($[9] !== t6) {
    t7 = clsx("relative z-10 flex h-full flex-col xl:flex-row xl:justify-between", "xl:h-auto xl:overflow-y-visible", t6);
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = "Menu";
  const t9 = "index.tsx";
  const t10 = movedScroll && "translate-y-0 bg-transparent";
  let t11;
  if ($[11] !== t10) {
    t11 = clsx("pointer-events-none fixed top-0 left-0 h-[88px] w-full -translate-y-full bg-white transition-transform", t10);
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11) {
    t12 = <div className={t11} />;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = "flex flex-col xl:flex-row";
  let t14;
  if ($[15] !== hideMenuOnClick) {
    t14 = () => hideMenuOnClick();
    $[15] = hideMenuOnClick;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SiteLogo className="h-8" data-sentry-element="SiteLogo" data-sentry-source-file="index.tsx" />;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t14) {
    t16 = <Link onClick={t14} href="/" className="flex items-center px-7 py-4 xl:px-0" aria-label="link to home page" data-sentry-element="Link" data-sentry-source-file="index.tsx">{t15}</Link>;
    $[18] = t14;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setShowMenu(_temp);
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== showMenu) {
    t18 = <button className="mt-6 mr-6 mb-4 flex h-11 w-11 items-center justify-center rounded-full border border-gray-200 xl:hidden" onClick={t17} aria-label="menu button">{showMenu ? <HamburgerClosed className="h-6 w-6 text-gray-900" /> : <HamburgerOpen className="h-5 w-5 text-gray-900" />}</button>;
    $[21] = showMenu;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t16 || $[24] !== t18) {
    t19 = <div className="sticky top-0 z-20 flex justify-between bg-white md:bg-transparent xl:static xl:pt-3 xl:pr-10">{t16}{t18}</div>;
    $[23] = t16;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  const t20 = showMenu ? "h-auto" : "h-0 xl:h-auto";
  let t21;
  if ($[26] !== t20) {
    t21 = clsx("flex w-full items-center justify-between", t20);
    $[26] = t20;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  const t22 = !showMenu;
  const t23 = !isMyAccountLink;
  let t24;
  if ($[28] !== isMyAccountLink || $[29] !== showMenu || $[30] !== t22 || $[31] !== t23) {
    t24 = clsx("z-10 flex w-full flex-col items-center pl-0 xl:mb-0 xl:h-full xl:flex-row xl:transition-opacity xl:duration-200", {
      "opacity-100": showMenu,
      "hidden opacity-0 xl:flex xl:opacity-100": t22,
      "mb-6": t23,
      "mb-0": isMyAccountLink
    });
    $[28] = isMyAccountLink;
    $[29] = showMenu;
    $[30] = t22;
    $[31] = t23;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  const t26 = headerItems.map((t25, index_0) => {
    const {
      data: item
    } = t25;
    return item?.link?.link_type === "Any" ? <div style={{
      order: index_0
    }} role="button" tabIndex={0} aria-expanded={index_0 === openTab} className={clsx("flex h-full w-full items-center justify-between gap-1 xl:justify-start", "text-body-6 xl:text-menu font-semibold whitespace-nowrap text-gray-600 xl:font-medium", "z-10 px-7 py-3 xl:px-3.5 xl:pt-6", "hover:text-gray-600/50")} key={index_0} onClick={() => {
      if (!isDesktop) {
        setPrevTab(openTab);
        setOpenTab(prev_0 => index_0 == prev_0 ? -1 : index_0);
      }
    }} onKeyDown={event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        setPrevTab(openTab);
        setOpenTab(prev_1 => index_0 == prev_1 ? -1 : index_0);
      }
    }} onMouseEnter={() => handleMenuHover(index_0)} onMouseLeave={handleMenuLeave}>{item?.title}<ChevronDown className={clsx("h-4 w-4 scale-150 transition-transform xl:scale-100", {
        "rotate-180": index_0 == openTab
      })} /></div> : <PrismicNextLink onClick={() => hideMenuOnClick()} style={{
      order: index_0
    }} className="text-body-6 xl:text-menu z-10 flex h-full w-full items-center px-7 py-3 font-semibold whitespace-nowrap text-gray-600 hover:text-gray-600/50 xl:justify-center xl:px-3.5 xl:pt-6 xl:font-medium" key={index_0} field={item.link} lang={lang}>{item?.title}</PrismicNextLink>;
  });
  const t27 = headerItems[openTab > -1 ? openTab : prevTab]?.data;
  let t28;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
    $[33] = t28;
  } else {
    t28 = $[33];
  }
  let t29;
  if ($[34] !== handleMenuLeave || $[35] !== hideMenuOnClick || $[36] !== openTab || $[37] !== prevTab || $[38] !== t27) {
    t29 = <DropdownItem hideMenu={hideMenuOnClick} prevTab={prevTab} openTab={openTab} item={t27} onMouseEnter={t28} onMouseLeave={handleMenuLeave} data-sentry-element="DropdownItem" data-sentry-source-file="index.tsx" />;
    $[34] = handleMenuLeave;
    $[35] = hideMenuOnClick;
    $[36] = openTab;
    $[37] = prevTab;
    $[38] = t27;
    $[39] = t29;
  } else {
    t29 = $[39];
  }
  let t30;
  if ($[40] !== t24 || $[41] !== t26 || $[42] !== t29) {
    t30 = <div className={t24}>{t26}{t29}</div>;
    $[40] = t24;
    $[41] = t26;
    $[42] = t29;
    $[43] = t30;
  } else {
    t30 = $[43];
  }
  let t31;
  if ($[44] !== t21 || $[45] !== t30) {
    t31 = <div className={t21}>{t30}</div>;
    $[44] = t21;
    $[45] = t30;
    $[46] = t31;
  } else {
    t31 = $[46];
  }
  let t32;
  if ($[47] !== t19 || $[48] !== t31) {
    t32 = <div className={t13}>{t19}{t31}</div>;
    $[47] = t19;
    $[48] = t31;
    $[49] = t32;
  } else {
    t32 = $[49];
  }
  const t33 = showMenu ? "flex" : "hidden xl:flex";
  let t34;
  if ($[50] !== t33) {
    t34 = clsx(t33, "z-10 flex-col items-center gap-3 px-3 pb-4 xl:w-full xl:flex-row xl:justify-end xl:pt-3 xl:pb-0");
    $[50] = t33;
    $[51] = t34;
  } else {
    t34 = $[51];
  }
  let t35;
  if ($[52] !== hideMenuOnClick || $[53] !== isMyAccountLink || $[54] !== myAccountLink || $[55] !== myAccountText) {
    t35 = isMyAccountLink && <div className="flex w-full flex-col px-4 xl:hidden"><div className="h-px w-full bg-gray-100" /><PrismicNextLink field={myAccountLink} className="text-body-6 flex w-full items-center justify-between py-4 font-semibold text-gray-600 xl:hidden" onClick={() => hideMenuOnClick()}><span className="flex items-center gap-3"><ProfileTwoUserIcon className="h-5 w-5" />{myAccountText}</span><ChevronDown className="h-6 w-6 -rotate-90" /></PrismicNextLink></div>;
    $[52] = hideMenuOnClick;
    $[53] = isMyAccountLink;
    $[54] = myAccountLink;
    $[55] = myAccountText;
    $[56] = t35;
  } else {
    t35 = $[56];
  }
  let t36;
  if ($[57] !== hideMenuOnClick || $[58] !== isMyAccountLink || $[59] !== myAccountLink || $[60] !== myAccountText) {
    t36 = isMyAccountLink && <PrismicNextLink field={myAccountLink} className="text-menu hidden items-center gap-2 font-medium whitespace-nowrap text-gray-600 transition-opacity hover:opacity-50 xl:flex" onClick={hideMenuOnClick}><ProfileTwoUserIcon className="h-4 w-4 text-gray-500" />{myAccountText}</PrismicNextLink>;
    $[57] = hideMenuOnClick;
    $[58] = isMyAccountLink;
    $[59] = myAccountLink;
    $[60] = myAccountText;
    $[61] = t36;
  } else {
    t36 = $[61];
  }
  let t37;
  if ($[62] !== buttonItems || $[63] !== hideMenuOnClick) {
    let t38;
    if ($[65] !== hideMenuOnClick) {
      t38 = t39 => {
        const {
          text,
          variant,
          link
        } = t39;
        return <LinkButton key={text} className="w-full xl:max-w-41.5" variant={variant} field={link} onClick={hideMenuOnClick}>{text}</LinkButton>;
      };
      $[65] = hideMenuOnClick;
      $[66] = t38;
    } else {
      t38 = $[66];
    }
    t37 = buttonItems.map(t38);
    $[62] = buttonItems;
    $[63] = hideMenuOnClick;
    $[64] = t37;
  } else {
    t37 = $[64];
  }
  let t38;
  if ($[67] !== t37) {
    t38 = <div className="order-2 flex w-full auto-cols-fr grid-flow-col flex-col gap-3 xl:order-0 xl:grid xl:w-auto xl:auto-cols-[minmax(10.375rem,1fr)]">{t37}</div>;
    $[67] = t37;
    $[68] = t38;
  } else {
    t38 = $[68];
  }
  let t39;
  if ($[69] !== lang) {
    t39 = <LanguageSwitcher {...{
      lang
    }} desktopFrom="xl" data-sentry-element="LanguageSwitcher" data-sentry-source-file="index.tsx" />;
    $[69] = lang;
    $[70] = t39;
  } else {
    t39 = $[70];
  }
  let t40;
  if ($[71] !== t34 || $[72] !== t35 || $[73] !== t36 || $[74] !== t38 || $[75] !== t39) {
    t40 = <div className={t34}>{t35}{t36}{t38}{t39}</div>;
    $[71] = t34;
    $[72] = t35;
    $[73] = t36;
    $[74] = t38;
    $[75] = t39;
    $[76] = t40;
  } else {
    t40 = $[76];
  }
  let t41;
  if ($[77] !== t12 || $[78] !== t32 || $[79] !== t40 || $[80] !== t7) {
    t41 = <div ref={ref} className={t7} data-sentry-component={t8} data-sentry-source-file={t9}>{t12}{t32}{t40}</div>;
    $[77] = t12;
    $[78] = t32;
    $[79] = t40;
    $[80] = t7;
    $[81] = t41;
  } else {
    t41 = $[81];
  }
  return t41;
};
export default Menu;
function _temp(prev) {
  return !prev;
}